import { Stack, Typography } from "@mui/material";

import {
  ProductUpdate,
  ProductUpdatePcm,
} from "api/memberPortal/product/productUpdate/productUpdate.types";
import ProductUpdateDisplay from "features/memberPortal/products/productDetails/ProductUpdates/components/ProductUpdateDisplay";

interface ProductUpdatesProps {
  productUpdates: ProductUpdate[] | ProductUpdatePcm[];
}

const ProductUpdates = ({ productUpdates }: ProductUpdatesProps) => {
  return (
    <Stack spacing={2} mt={3.5}>
      {productUpdates?.length ? (
        productUpdates.map((item) => (
          <ProductUpdateDisplay
            content={item.content}
            severity={item.severity}
            title={item.title}
            key={item.id}
          />
        ))
      ) : (
        <Typography variant="body2" fontStyle="italic" m={1} textAlign="center">
          There are no updates for this product at this time
        </Typography>
      )}
    </Stack>
  );
};
export default ProductUpdates;
